export default "__VITE_ASSET__0b218ead__"